
export const animatedScrollTo = (elem: HTMLElement | number | null, speed?: number, easing?: "easeOutSine" | "easeInOutSine" | "easeInOutQuint") => {
    // scrollTargetY: the target scrollY property of the window
    // speed: time in pixels per second
    // easing: easing equation to use

    let currentTime = 0;

    const scrollY = window.scrollY || document.documentElement.scrollTop;
    // Scroll a little above target.
    const scrollTargetY = (elem !== null && typeof elem === "number")
        ? elem
        : elem
            ? Math.max(0, elem.offsetTop - 15)
            : 0;
    const speedValue = speed || 2000;
    const easingValue = easing || 'easeOutSine';

    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speedValue, .8));

    // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
    const easingEquations = {
        easeOutSine(pos: number) {
            return Math.sin(pos * (Math.PI / 2));
        },
        easeInOutSine(pos: number) {
            return (-0.5 * (Math.cos(Math.PI * pos) - 1));
        },
        easeInOutQuint(pos: number) {
            pos /= 0.5;
            if (pos < 1) {
                return 0.5 * Math.pow(pos, 5);
            }
            return 0.5 * (Math.pow((pos - 2), 5) + 2);
        },
    };

    // add animation loop
    function tick() {
        currentTime += 1 / 60;

        const p = currentTime / time;
        const t = easingEquations[easingValue](p);

        if (p < 1) {
            requestAnimationFrame(tick);

            window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        } else {
            window.scrollTo(0, scrollTargetY);
        }
    }

    // call it once to get started
    tick();
};
